// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_JRE","cls2":"Comments-cls2_Crd Comments-cls1_JRE"};